

import React, { Component } from 'react';
import './Style.css';
import NotFound from '../../../images/empty.svg';
import '../../../custom.css';
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import selectImage from '../../../images/select-meta.svg';

export class Letter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            goals: [],
            history:[],
            model: {
                id: 0
            },
            topics: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            showBtnSend: false,
            modelHistory: {},
            isText: true,
            filterParam: '',
            seniors: [],
            modelPermission: { Permission: 'Solo lectura' },
            seniorPermission: [],
            historyId: window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
        }

    }

    componentDidMount() {

        this.GetGoalByUserId();
        this.GetAllTopicsActive();
        this.GetSeniorThisLetter();
    }

    componentDidUpdate() {

        if (document.querySelector(".drop_box")) {
            const dropArea = document.querySelector(".drop_box"),
                buttonFile = dropArea.querySelector("button"),
                input = dropArea.querySelector("input");

            buttonFile.onclick = () => {
                input.click();
            };
        }

        document.querySelector('#currentUser').innerHTML = document.querySelector('#hiddenName') ? document.querySelector('#hiddenName').value : '';
        if (this.state.historyId && document.querySelector(`#meta${this.state.historyId}`)) {
            document.querySelector(`#meta${this.state.historyId}`).click();
            this.setState({ historyId: null });
        }
    }

    async GetGoalByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetGoalByUserId`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ goals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetHistoryGoal(goalId) {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetHistoryGoal?goalId=${goalId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ history: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando el detalle de la meta',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetAllTopicsActive() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Topic/GetAllTopicsActive`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ topics: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los temas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async addGoal() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/AddGoal`, request);

        this.setState({ loading: false });
        document.querySelector('#closeModalGoal').click();

        if (response.status == 200) {
            this.GetGoalByUserId();

            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Meta guardada con éxito.',
                    Type: 'alert-success',
                    Show: true
                }, model: {id: 0}
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puedo guardar la meta.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    getBase64(file, source) {
        var context = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {

            if (source == 'Goal') {
                var model = context.state.model;
                model.newPhoto = reader.result;
                model.photo = reader.result;
                context.setState({ model: model, FileName: file.name });
            }

            if (source == 'Evidence') {
                var modelHistory = context.state.modelHistory;
                modelHistory.InnerHtml = reader.result;
                modelHistory.Type = 'Image';
                context.setState({ modelHistory: modelHistory, isImage: true, isText: false, showBtnSend: true })
            }
        };
        reader.onerror = function (error) {
            alert("Error subiendo imagen, por favor inténtelo de nuevo.")
        };
    }

    selectedImage(e, source) {
        if (e.currentTarget.files.length > 0) {
            this.getBase64(e.currentTarget.files[0], source)
        }
    }

    async addHistory(type) {

        var model = this.state.modelHistory;
        model.GoalId = this.state.GoalId;
        this.setState({ modelHistory: model });

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify(this.state.modelHistory)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/AddHistoryGoal`, request);

        this.setState({ loading: false });

        if (response.status == 200) {

            const data = await response.json();

            if (this.state.isText) {
                document.querySelector('#textInnerHtml').value = '';
            }
            this.setState({ isImage: false, isText: true, history: data, modelHistory: {}, showBtnSend: false });

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando la evidencia',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetUsersByName(param) {

        if (param.length < 3) {
            return;
        }

        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Users/GetUsersByName?param=${param}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ seniors: data.result });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async AddSeniorPermission() {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify(this.state.modelPermission)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/AddSeniorPermission`, request);

        this.setState({ loading: false });

        if (response.status == 200) {

            const data = await response.json();
            document.querySelector('#closeModalSenior').click();
            
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'el senior ha sido agregado a la carta de logro',
                    Type: 'alert-success',
                    Show: true
                }, seniorPermission: data, modelPermission: { Permission: 'Solo lectura' }, SelectedSenior: null, selectedSeniorName: ''
            });

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando el senior',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetSeniorThisLetter() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetSeniorThisLetter`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ seniorPermission: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los senior de la carta',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async DeleteSenior(userId) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/DeleteSenior?userId=${userId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Senior eliminado correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
            this.GetSeniorThisLetter();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los senior de la carta',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async DeleteGoal(goalId) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/DeleteGoal?goalId=${goalId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'la meta se ha borrado correctamente.',
                    Type: 'alert-success',
                    Show: true
                }
            });
            this.GetGoalByUserId();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'borrando la meta',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async closeLetter() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/CloseLetter`, request);

        this.setState({ loading: false });

        document.querySelector('#closeModalCloseLetter').click();

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'la carta se ha cerrado correctamente.',
                    Type: 'alert-success',
                    Show: true
                }
            });
            this.GetGoalByUserId();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'cerrando la carta de logros',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async openImage(e) {
        this.setState({ imageSelected: e.currentTarget.src })
        document.querySelector('#btnOpenImage').click();
    }

    render() {

        return (
            <div className="mt-5 row">

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Carta de logros</li>
                    </ol>
                </nav>

                <div class="modal fade" id="seniorModal" tabindex="-1" role="dialog" aria-labelledby="seniorModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Agregar senior</h5>
                                <button type="button" id="closeModalSenior" class="closeModal" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <div class="form-group row">
                                    <div className="col-12">
                                        <label for="title">Buscar senior</label>
                                        <input type="text" className="form-control" value={this.state.selectedSeniorName} onChange={(e) => {
                                            this.setState({ selectedSeniorName: e.currentTarget.value })
                                            this.GetUsersByName(e.currentTarget.value)
                                        }} onClick={() => {
                                            this.setState({
                                                selectedSeniorName: this.state.SelectedSenior ? '' : this.state.selectedSeniorName,
                                                SelectedSenior: null
                                            })
                                        }}></input>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div className="col-12">
                                        <ul className="wrapp-senior">
                                            {
                                                this.state.seniors.map(a => <li onClick={() => {

                                                    var model = this.state.modelPermission;
                                                    model.UserId = a.id;
                                                    this.setState({ SelectedSenior: a.id, selectedSeniorName: a.fullName, seniors: [], filterParam: '', modelPermission: model });

                                                }}>{a.fullName}</li>)
                                            }
                                        </ul>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div className="col-12">
                                        <label for="title">Asignar permiso</label>
                                        <select className="form-control" onChange={(e) => {
                                            var model = this.state.modelPermission;
                                            model.Permission = e.currentTarget.value;
                                            this.setState({ modelPermission: model });
                                        }}>
                                            <option value="Solo lectura" selected={this.state.modelPermission.Permission == 'Solo lectura'}>Solo lectura</option>
                                            <option value="Calificador" selected={this.state.modelPermission.Permission == 'Calificador'}>Calificador</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <input type="button" className="btn btn-primary" value="Guardar" disabled={!this.state.SelectedSenior} onClick={() => { this.AddSeniorPermission() }}></input>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="closeLetterModal" tabindex="-1" role="dialog" aria-labelledby="closeLetterModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Cerrar carta de logros</h5>
                                <button type="button" id="closeModalCloseLetter" class="closeModal" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <p>
                                    Estas seguro de cerrar tu Carta de Logros?<br></br><br></br>

                                    Ten en cuenta que esto solo se hace al final del proceso cuando tus senior revisaron tu proceso y lo aprobaron o cuando tus metas se han cumplido y quieres reiniciar tu carta de logros.<br></br><br></br>

                                    Cerrar tu carta de logros pondrá tu porcentaje de nuevo en cero y podrás crear una carta de logros completamente nueva.<br></br><br></br>

                                    No te preocupes podrás ver todo lo que has logrado en LIFE pues dejaremos el registro de tus metas para que mires todo lo que has logrado después de tu proceso.<br></br><br></br>
                                </p>

                                <label for="checkCloseLetter">
                                    <input id="checkCloseLetter" type="checkbox" onClick={(e) => { this.setState({ enableCloseLetter: e.currentTarget.checked }) }}></input>Si marcas este espacio se habilitará el botón de Terminar Carta de Logros.
                                </label>

                            </div>
                            <div class="modal-footer">
                                <input type="button" className="btn btn-primary" value="Terminar carta de logros" disabled={!this.state.enableCloseLetter} onClick={() => { this.closeLetter() }}></input>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    

                    <div hidden>
                        <button id="openModalActions" type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalActions" onClick={() => { this.setState({ canDelete: false }) }}>
                            Crear meta
                        </button> 
                    </div>

                    <div class="modal fade" id="modalActions" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">Agregar o editar meta</h5>
                                    <button type="button" id="closeModalGoal" class="closeModal" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">

                                    <div className="form-group text-center">
                                        <div class="card">
                                            {
                                                !this.state.model.photo ?
                                                    <div class="drop_box">
                                                        <header>
                                                            <h4>Seleccione foto</h4>
                                                        </header>
                                                        <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                                        <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'Goal') }} />
                                                        <button class="btn">Seleccionar foto</button>
                                                    </div>
                                                    :
                                                    <div class="image-is-selected" >
                                                        <h4>{this.state.FileName}</h4>
                                                        <img src={this.state.model.photo} width="200px" />
                                                        <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                            var model = this.state.model;
                                                            model.photo = '';
                                                            this.setState({ model: model })
                                                        }} />
                                                    </div>
                                            }


                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div className="col-12">
                                            <label for="title">Titulo de la meta</label>
                                            <input type="text" class="form-control" id="description" maxLength="200" value={this.state.model.title} onChange={e => {
                                                var model = this.state.model;
                                                model.title = e.currentTarget.value;
                                                this.setState({ model: model })
                                            }}></input>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div className="col-12">
                                            <label for="title">Descripción</label>
                                            <textarea type="text" class="form-control" id="description" maxLength="4000" value={this.state.model.description} onChange={e => {
                                                var model = this.state.model;
                                                model.description = e.currentTarget.value;
                                                this.setState({ model: model })
                                            }}></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div className="col-12">
                                            <label for="title">Área</label>
                                            <select className="form-control" onChange={(e) => {
                                                var model = this.state.model;
                                                model.topic = parseInt(e.currentTarget.value);
                                                this.setState({ model: model })
                                            }}>
                                                <option value="">Seleccione una</option>
                                                {
                                                    this.state.topics.map(c => <option value={c.id} selected={c.id == this.state.model.topic}>{c.title}</option>)
                                                }
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">

                                    <input type="button" className="btn btn-primary" value="Guardar" disabled={!this.state.model.title || !this.state.model.description || !this.state.model.topic || !this.state.model.photo} onClick={() => { this.addGoal() }}></input>

                                    {
                                        this.state.model.id > 0 ?
                                            <label for="checkDeleteGoal" className="small text-small">
                                                <input type="checkbox" checked={this.state.canDelete} id="checkDeleteGoal" onClick={(e) => { this.setState({ canDelete: e.currentTarget.checked }) }}></input>
                                            Al seleccionar esta casilla se habilitará el botón de eliminar y aceptas que si eliminas la meta eres consciente que la información no se podrá recuperar
                                            </label> : null
                                    }

                                    {
                                        this.state.model.id > 0 ?
                                            <button type="button" class="btn btn-danger" data-dismiss="modal" disabled={!this.state.canDelete} onClick={() => { this.DeleteGoal(this.state.model.id) }}>Eliminar</button> : null
                                    }
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" onClick={() => { this.GetGoalByUserId(); }}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row col-lg-12 pre-line-text">
                    <div className="col-lg-5 border panel-goals">

                        <div class="btn-group w-100">
                            <button type="button" class="dropdown-toggle form-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span id="currentUser"></span>
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" data-toggle="modal" data-target="#modalActions" href="#" onClick={() => {
                                    this.setState({ model: { id: 0, title: '', description: '', topic: '', newPhoto: '' }, canDelete: false})

                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
                                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                    Crear meta
                                </a>
                                <div class="dropdown-divider"></div>

                                <a class="dropdown-item" data-toggle="modal" data-target="#closeLetterModal" href="#" onClick={() => {
                                   
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
                                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                    Cerrar carta de logros
                                </a>
                                <div class="dropdown-divider"></div>

                                <h6 className="text-small small dropdown-item">Quién puede calificar</h6>
                                <div class="dropdown-divider"></div>

                                {
                                    this.state.seniorPermission.filter(a => a.permission == 'Calificador').length == 0 ?
                                        <span className="dropdown-item small text-small">Solo tú</span> : null
                                }

                                {
                                    this.state.seniorPermission.filter(a => a.permission == 'Calificador').map(e => <li className="row">
                                        <div className="col-lg-8">
                                            <b className="dropdown-item small text-small">{e.seniorName}</b>
                                        </div>
                                        <div className="col-lg-2 cursor-pointer" onClick={() => { this.DeleteSenior(e.userId) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-x-fill" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6.146-2.854a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </div>
                                    </li>)
                                }
                                <div class="dropdown-divider"></div>
                                <h6 className="text-small small dropdown-item">Quién puede ver</h6>
                                <div class="dropdown-divider"></div>

                                {
                                    this.state.seniorPermission.filter(a => a.permission != 'Calificador').length == 0 ?
                                        <span className="dropdown-item small text-small">Solo tú</span> : null
                                }

                                {
                                    this.state.seniorPermission.filter(a => a.permission != 'Calificador').map(e => <li className="row">
                                        <div className="col-lg-8">
                                            <b className="dropdown-item small text-small">{e.seniorName}</b>
                                        </div>
                                        <div className="col-lg-2 cursor-pointer" onClick={() => { this.DeleteSenior(e.userId) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-x-fill" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6.146-2.854a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </div>
                                    </li>)
                                }

                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" data-toggle="modal" data-target="#seniorModal" href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-add" viewBox="0 0 16 16">
                                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                        <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z" />
                                    </svg>
                                    Agregar senior
                                </a>
                            </div>
                        </div>

                        {this.state.goals.length == 0 ?
                            <div class="alert alert-info d-flex align-items-center" role="alert">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                    </svg>
                                    <div>
                                    Aún no has configurado metas
                                    </div>
                                </div> 
                            : null}

                        {
                            this.state.goals.map(e =>

                                <div>

                                    <li class="list-group-item border-bottom d-flex">
                                        <div className="col-1">
                                            <span className={`letterNotification ${e.goalIsAlready ? 'green' : ''} ${ !e.isActive ? 'red' : ''}`}></span>
                                        </div>
                                        <div className="col-3">
                                            {e.photo ? <img src={e.photo} className="w-100 pointer" onClick={(e) => { this.openImage(e) }}/> : <img className="w-100" src={require('../../../images/avatar.png')} />}
                                        </div>
                                        <div className="col-7">
                                            <h6 id={`meta${e.id}`} className="cursor-pointer" onClick={() => {
                                                this.GetHistoryGoal(e.id);
                                                this.setState({ goalDescription: e.description, GoalId: e.id})
                                            }}>{e.title}</h6>
                                            <span className="text-small small">{e.topicName}</span>
                                        </div>
                                        <div className="col-1 cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16" onClick={() => {
                                                
                                                document.querySelector('#openModalActions').click();
                                                this.setState({ model: e });

                                            }}>
                                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                                </svg>
                                        </div>
                                    </li>


                                </div>

                            )
                        }

                        <button id="btnOpenImage" data-toggle="modal" data-target="#openImage" hidden></button>
                        <div class="modal fade" id="openImage" tabindex="-1" role="dialog" aria-labelledby="closeLetterModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Cerrar carta de logros</h5>
                                        <button type="button" id="closeModalCloseLetter" class="closeModal" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">

                                        <img src={this.state.imageSelected} />

                                    </div>
                                    <div class="modal-footer"> <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-7 border panel-evidence">

                        {
                            !this.state.GoalId || this.state.GoalId == 0 ?
                                <div>
                                    <img className="" src={selectImage} />
                                    <span>En esta sección podrás ver el avance de las metas, pero antes debes seleccionar una de ellas.</span>
                                </div> : null
                        }

                        {
                            this.state.goalDescription ?
                                <div class="alert alert-success d-flex align-items-center" role="alert">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                    </svg>
                                    <div>
                                        {this.state.goalDescription}
                                    </div>
                                </div> :
                                null
                        }

                        {
                            this.state.history.map(e =>


                                <div>
                                    {
                                        e.type == 'Text' ?
                                            <li class="bubble">
                                                <div className="text-small small"><b>{e.author}</b><b className="float-right">{new Date(e.createOnDate).toLocaleDateString()}</b></div>
                                                {e.innerHtml}
                                            </li> : null
                                    }
                                    {
                                        e.type == 'Image' ?
                                            <li class="image">
                                                <div className="text-small small"><b>{e.author}</b><b className="float-right">{new Date(e.createOnDate).toLocaleDateString()}</b></div>
                                                <img src={e.innerHtml}></img>
                                            </li> : null
                                    }
                                </div>

                            )
                        }

                        

                        
                    </div>
                    
                </div>
                <div className="row col-lg-12">
                    {
                        this.state.GoalId && this.state.GoalId > 0 ?
                            <div className="row bottom">
                                <div className="col-lg-10">
                                    {

                                        this.state.isText ?
                                            <textarea id="textInnerHtml" className="form-control" rows="1" onChange={(h) => {

                                                var model = this.state.modelHistory;
                                                model.InnerHtml = h.currentTarget.value;
                                                model.Type = 'Text';
                                                this.setState({ modelHistory: model });

                                                this.setState({ showBtnSend: (h.currentTarget.value.length > 0), modelHistory: model, historyType: 'Text' });
                                            }}></textarea> :
                                            null

                                    }

                                    {

                                        this.state.isImage ?
                                            <div class="image-is-selected" >
                                                <div>
                                                    <img src={this.state.modelHistory.InnerHtml} width="200px" />
                                                </div>

                                                <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                    var model = this.state.modelHistory;
                                                    model.InnerHtml = '';
                                                    model.Type = 'Text';
                                                    this.setState({ modelHistory: model, isImage: false, isText: true, showBtnSend: false })
                                                }} />
                                            </div> :
                                            null

                                    }

                                </div>

                                {
                                    this.state.showBtnSend ?
                                        <div className="col-lg-2">
                                            <input type="button" value="Enviar" className="btn btn-primary send" onClick={() => {

                                                this.addHistory();

                                            }}></input>
                                        </div> :
                                        null
                                }

                                {
                                    !this.state.showBtnSend ?
                                        <div className="row">
                                            <div className="col-lg-2 cursor-pointer">

                                                <input type="file" accept="image/*" id="fileImage" style={{ "display": "none" }} onChange={(e) => {
                                                    this.selectedImage(e, 'Evidence')
                                                }} />

                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-image" viewBox="0 0 16 16" onClick={() => {

                                                    document.querySelector('#fileImage').click();
                                                }}>
                                                    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                    <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z" />
                                                </svg>
                                            </div>
                                        </div> :
                                        null
                                }

                            </div>
                            :
                            null
                    }
                </div>
               

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
